import React from "react"
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOSvg from "../../fundamentals/CCOSvg";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import {stripTreeText} from "../../../utility/componentUtil";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import useWindowSize from "../../../utility/useWindowSize";
import {SosTextfragmentType} from "../../types";

export interface Props {
    sosTextFragment: SosTextfragmentType
    className?: string
    insideCarousel?: boolean
}

function C027Quote(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const {greaterThanWindowMedium, greaterThanWindowLarge, lowerThanWindowSmall} = useWindowSize();
    // Indirektion aus SOSHDL-448: Wenn bei Textfragment der Detailtext gesetzt ist, wird der verwendet.
    // Nur, wenn der leer ist, dann wird auf den Teaser-Text zurückgegriffen.
    let propName = 'properties.detailText';
    let teaserText;
    if (props.sosTextFragment.detailText) {
        teaserText = stripTreeText(props.sosTextFragment.detailText.textAsTree);
    } else if (props.sosTextFragment.teaserText) {
        teaserText = stripTreeText(props.sosTextFragment.teaserText.textAsTree);
        propName = 'properties.teaserText';
    }
    return (
        <CCOComponentWrapper className={props.className ?? 'carousel-content'} noTopMargin={true}
                                     fullWidthOnMobile={true}>
            <CCOContainer id={props.sosTextFragment.id} background={"primary.main"} width={'large'}
                          sx={{
                              height: {xl: '624px', lg: '372px', md: '267px', xs: undefined},
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              aspectRatio: {xs: '1/1', md: undefined},
                          }}
            >
                <Stack
                    spacing={{xl: 3, lg: 3, md: 2, sm: 2, xs: 2}}
                    sx={{
                        height: '100%!important',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 6
                    }}>
                    <Stack spacing={{xl: 3, lg: 2, md: 2, sm: 2, xs: 2}}>
                        <CCOSvg src={'/quote.svg'} size={38}/>
                        <Typography
                            {...metaDataProperty(isPreview,
                                propName,
                                props.sosTextFragment.id)}
                            variant={lowerThanWindowSmall ? 'h4' : greaterThanWindowMedium && !greaterThanWindowLarge ? 'h4' : 'h3'}
                            align={'center'}
                            sx={{
                                color: 'primary.contrastText'
                            }}>
                            {teaserText}
                        </Typography>
                    </Stack>
                    <Typography
                        align={'center'}
                        variant={'body2'}
                        {...metaDataProperty(isPreview, 'properties.teaserTitle', props.sosTextFragment.id)}
                        sx={{
                            color: 'primary.contrastText'
                        }}>
                        {props.sosTextFragment.teaserTitle!}
                    </Typography>
                </Stack>
            </CCOContainer>
        </CCOComponentWrapper>
    );
}

export default C027Quote;